<template>
  <O3D>
    <!-- <TextClicker :sx="10" :sy="10" :sz="10" :py="200" :text="name"></TextClicker> -->
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { MeshBasicMaterial, Mesh, Object3D, OctahedronBufferGeometry } from 'three'
// import { SphereBufferGeometry, MeshBasicMaterial, Mesh } from 'three'
// let copy2clip = require('copy-to-clipboard')

export default {
  props: {
    opacity: {
      default: 0.15
    }
  },
  mixins: [
    O3DG2
  ],
  data () {
    return {
      o3d2: false
    }
  },
  async mounted () {
    this.run()
  },
  beforeDestroy () {
    if (this.o3d2) {
      this.o3d2.parent.remove(this.o3d2)
    }
  },
  methods: {
    async run () {
      if (this.o3d2) {
        this.o3d2.parent.remove(this.o3d2)
      }

      let o3d2 = this.o3d2 = new Object3D()
      // let planeGeo = new BoxBufferGeometry(500, 0.01, 500, 2, 2, 2)
      // let planeMat = new MeshBasicMaterial({ color: 0xffffff, opacity: this.opacity, transparent: true })
      // let planeMesh = new Mesh(planeGeo, planeMat)

      // this.onClean(() => {
      //   planeGeo.dispose()
      //   planeMat.dispose()
      // })
      // o3d2.add(planeMesh)

      // let sync = () => {
      //   planeMesh.position.copy(this.o3d.position)
      // }
      // sync()
      // this.$watch('px', sync)
      // this.$watch('py', sync)
      // this.$watch('pz', sync)

      // this.$watch('opacity', () => {
      //   planeMat.opacity = this.opacity
      // })


      let geo = new OctahedronBufferGeometry(2.5, 0)
      geo.translate(0, 1.5 + 0.5 + 0.7, 0)
      let mat = new MeshBasicMaterial({ color: 0xff0000, wireframe: true })
      let mesh = new Mesh(geo, mat)
      this.onClean(() => {
        geo.dispose()
        mat.dispose()
      })
      o3d2.add(mesh)

      this.onLoop(() => {
        mesh.rotation.y += 0.01
      })

      if (this.ctx.rayplay) {
        // this.onClean(() => {
        //   this.ctx.rayplay.remove(planeMesh)
        // })
        this.$root.$on('placer-pt', (pt) => {
          mesh.position.x = pt.x
          mesh.position.y = pt.y
          mesh.position.z = pt.z
        })

    //     this.ctx.rayplay.add(planeMesh, (ev) => {
    //       console.log(ev.object.name, ev.event.point)
    //       mesh.position.x = ev.event.point.x
    //       mesh.position.y = ev.event.point.y
    //       mesh.position.z = ev.event.point.z

    // //       let tags = `:scale="{ x: 1 / 100, y: 1 / 100, z: 1 / 100 }" :position="{ x: ${ev.event.point.x.toFixed(2)}, y: ${ev.event.point.y.toFixed(2)} - -31.85 / 100, z: ${ev.event.point.z.toFixed(2)} }"`
    // //       tags = `
    // // <O3D ${tags}>
    // //   <IsoVisual :name="'Palm_0'"></IsoVisual>
    // // </O3D>
    // //       `
    //       // copy2clip(tags)

    //       // this.$root.$emit('iso-placer-click', ev.event.point)
    //     })
      }

      this.ctx.scene.add(o3d2)

      // this.$root.$on('pt-click', (ev) => {
      //   this.o3d.scale.set(0.2, 0.2, 0.2)
      //   this.o3d.position.set(
      //     ev.event.point.x,
      //     ev.event.point.y + 63.03 * 0.333,
      //     ev.event.point.z,
      //   )
      // })

      // this.ctx.scene.ptMesh.position.set(
      //   ev.event.point.x,
      //   ev.event.point.y,
      //   ev.event.point.z
      // )
    }
  }
}
</script>

<style>
</style>